import './App.css';
import Helmet from 'react-helmet';
import R from 'ramda';
import React from 'react';
import favicon from '../../common/app/favicon';
import start from '../../common/app/start';
import { Match } from '../../common/app/components';
import { Miss } from 'react-router';
import { connect } from 'react-redux';
import './icons/style.css';
import NotFoundPage from '../notfound/NotFoundPage';
import PropertiesPage from '../properties/PropertiesPage';
import MyPropertiesPage from '../properties/MyPropertiesPage';
import PropertyDetailsPage from '../propertyDetails/PropertyDetailsPage';
import PropertyCreatePage from '../propertyCreate/PropertyCreatePage';
import PropertyEditPage from '../propertyEdit/PropertyEditPage';

const bootstrap4Metas = [
  { charset: 'utf-8' },
  {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0, shrink-to-fit=no',
  },
  {
    'http-equiv': 'x-ua-compatible',
    content: 'ie=edge',
  },
];

const App = ({ currentLocale }) => (
  <div>
    <Helmet
      htmlAttributes={{ lang: currentLocale }}
      title="Húsfinnur"
      meta={[
        ...bootstrap4Metas,
        { name: 'description', content: 'Finndu og auglýstu eignir til leigu á einfaldan og fljótlegan hátt með Húsfinn!' },
        { name: 'keywords', content: 'leiga, leigu, leigja, íbúð, hergbergi, hús, atvinnuhúsnæði, leigjandi, leigusali, reykjavík, ísland, rent, apartment, house, room, iceland' },
        { name: 'author', content: 'Reon ehf' },
        { name: 'copyright', content: 'Reon ehf' },
        { property: 'og:title', content: 'Húsfinnur' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'www.husfinnur.is' },
        { property: 'fb:app_id', content: '218266818612795' },
        { property: 'og:image', content: 'https://firebasestorage.googleapis.com/v0/b/rentimizer-e5308.appspot.com/o/facebook-share-photo.png?alt=media&token=71858102-ffa8-48a5-b646-57eb93c5336f' },
        { property: 'og:image:type', content: 'image/png' },
        { property: 'og:description', content: 'Finndu og auglýstu eignir til leigu á einfaldan og fljótlegan hátt með Húsfinn!' },
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:title', content: 'Húsfinnur' },
        { name: 'twitter:description', content: 'Finndu og auglýstu eignir til leigu á einfaldan og fljótlegan hátt með Húsfinn!' },
        ...favicon.meta,
      ]}
      link={[
        ...favicon.link,
        {
          href: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700',
          rel: 'stylesheet',
        },
        {
          href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css',
          rel: 'stylesheet',
          type: 'text/css',
        },
        {
          href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css',
          rel: 'stylesheet',
          type: 'text/css',
        },
      ]}
      script={[
        {
          src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBrUzJyYxVsSpMXlBXWhlBv387cAgSb6H0&libraries=geometry,drawing,places,visualization"',
        },
      ]}
    />
    <Match exactly pattern="/" component={PropertiesPage} />
    <Match exactly pattern="/properties" component={PropertiesPage} />
    <Match exactly pattern="/myProperties" component={MyPropertiesPage} />
    <Match exactly pattern="/properties/:propertyId" component={PropertyDetailsPage} />
    <Match exactly pattern="/createProperty" component={PropertyCreatePage} />
    <Match exactly pattern="/editProperty/:propertyId" component={PropertyEditPage} />
    <Miss component={NotFoundPage} />
  </div>
);

App.propTypes = {
  currentLocale: React.PropTypes.string.isRequired,
  currentTheme: React.PropTypes.string,
};

export default R.compose(
  connect(
    (state: State) => ({
      currentLocale: state.intl.currentLocale,
      currentTheme: state.themes.currentTheme,
    }),
  ),
  start,
)(App);



// WEBPACK FOOTER //
// ./src/browser/app/App.js